const noKaderImg = new URL("../assets/img/geen-lijst.webp", import.meta.url)
  .href;
const withKaderImg = new URL(
  "../assets/img/kaders/kader-classic.webp",
  import.meta.url,
).href;
const heartKaderImg = new URL(
  "../assets/img/kaders/kader-heart.webp",
  import.meta.url,
).href;
const circleKaderImg = new URL(
  "../assets/img/kaders/kader-circle.webp",
  import.meta.url,
).href;
const delftKaderImg = new URL(
  "../assets/img/kaders/kader-delft.webp",
  import.meta.url,
).href;
const cardWidth = "22%";

class KaderSelector extends HTMLElement {
  state = {
    printType: "paper",
    posterKader: "with",
    posterOrientation: "portrait",
  };

  disabledByPrintType = {
    paper: ["delft"],
    acryl: ["delft"],
    aluminium: ["delft"],
    tegel: ["heart", "circle", "with"],
  };

  connectedCallback() {
    this.render();
    this.bindEvents();
    this.applyAll();
  }

  setState(next = {}) {
    this.state = { ...this.state, ...next };
    this.applyAll();
  }

  bindEvents() {
    this.addEventListener("click", (e) => {
      const el = e.target.closest(".js-kader");
      if (!el || !this.contains(el)) return;

      const posterKader = String(el.dataset.posterKader);

      // als hij verborgen is: negeer klik
      if (el.classList.contains("d-none")) return;

      this.setState({ posterKader });

      // laat main.js weten dat er gekozen is
      this.dispatchEvent(
        new CustomEvent("kader-change", {
          detail: { posterKader },
          bubbles: true,
        }),
      );
    });
  }

  applyAll() {
    this.applyAvailability();
    this.applySelection();
  }

  applySelection() {
    const { posterKader } = this.state;
    this.querySelectorAll(".js-kader").forEach((el) => {
      el.classList.toggle(
        "active",
        String(el.dataset.posterKader) === String(posterKader),
      );
    });
  }

  applyAvailability() {
    const { printType, posterOrientation } = this.state;
    const posterStyle = window.PosterStyle;

    this.querySelectorAll(".js-kader").forEach((el) => {
      const id = String(el.dataset.posterKader);

      const disabledByPrintType = (
        this.disabledByPrintType[printType] ?? []
      ).includes(id);

      const disabledByOrientation =
        posterOrientation === "landscape" &&
        (id === "heart" || id === "circle");

      const disabledDelft =
        id === "delft" && !(printType === "tegel" && posterStyle === "9");

      const isDisabled =
        disabledByPrintType || disabledByOrientation || disabledDelft;

      el.classList.toggle("d-none", isDisabled);
    });
  }

  render() {
    const sportsmap = this.getAttribute("variant") === "sportsmap";

    this.innerHTML = /* html */ `
      <strong><small data-i18n="components.kaderSelector.title">Kies een kader</small></strong>
      <div class="d-flex flex-wrap gap-3 mb-3 mt-2">
          <div class="js-kader flex-shrink-0 selectable-card text-center p-1" style="flex-basis: ${cardWidth};"
              data-poster-kader="without">
            <img
              src="${noKaderImg}"
              class="img-fluid w-100 h-auto rounded"
            />
            <small data-i18n="components.kaderSelector.none">Geen</small>
          </div>
          <div class="js-kader flex-shrink-0 selectable-card text-center p-1" style="flex-basis: ${cardWidth};"
              data-poster-kader="with">
            <img
              src="${withKaderImg}"
              class="img-fluid w-100 h-auto rounded"
            />
            <small data-i18n="components.kaderSelector.classic">Klassiek</small>
          </div>
          ${sportsmap ? "" : /* html */ `<div class="js-kader flex-shrink-0 selectable-card text-center p-1" style="flex-basis: ${cardWidth};"
              data-poster-kader="heart">
            <img
              src="${heartKaderImg}"
              class="img-fluid w-100 h-auto rounded"
            />
            <small data-i18n="components.kaderSelector.heart">Hart</small>
          </div>
          <div class="js-kader flex-shrink-0 selectable-card text-center p-1" style="flex-basis: ${cardWidth};"
              data-poster-kader="circle">
            <img
              src="${circleKaderImg}"
              class="img-fluid w-100 h-auto rounded"
            />
            <small data-i18n="components.kaderSelector.circle">Cirkel</small>
          </div>
          <div class="js-kader flex-shrink-0 selectable-card text-center p-1" style="flex-basis: ${cardWidth};"
              data-poster-kader="delft">
            <img
              src="${delftKaderImg}"
              class="img-fluid w-100 h-auto rounded"
            />
            <small data-i18n="components.kaderSelector.delft">Delft</small>
          </div>`}
      </div>
    `;
  }
}

customElements.define("kader-selector", KaderSelector);
